<div class="dialog-wrapper" [formGroup]="form">

  <button class="close-btn" type="button" (click)="cancel()" aria-label="Cerrar">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="#2C2A29" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 6L18 18" stroke="#2C2A29" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div class="titulo">
    <img src="assets/agricola/action-update-payment.svg" class="titulo-mask" alt="" aria-hidden="true">
    <div class="titulo-texto">
      <h2 class="titulo-copy">Cambiar método de pago</h2>
      <p class="titulo-sub">Selecciona la nueva cuenta de cargo para el cliente</p>
    </div>
  </div>

  <div class="fields">

    <div class="field-half">
      <app-sis-field label="Código de gestión" formControlName="managementCode"></app-sis-field>
    </div>

    <div class="current-account-card" *ngIf="data.currentAccount">
      <p class="current-account-label">Cuenta de cargo actual</p>
      <div class="current-account-row">
        <div class="current-account-field">
          <span class="current-account-sublabel">No. Cuenta</span>
          <span class="current-account-value">{{ data.currentAccount.accountNumber }}</span>
        </div>
        <div class="current-account-field">
          <span class="current-account-sublabel">Tipo</span>
          <span class="current-account-value">{{ data.currentAccount.accountType }}</span>
        </div>
        <div class="current-account-field">
          <span class="current-account-sublabel">Nombre</span>
          <span class="current-account-value">{{ data.currentAccount.accountName }}</span>
        </div>
        <div class="current-account-field">
          <span class="current-account-sublabel">Estado</span>
          <span class="current-account-value">{{ data.currentAccount.status }}</span>
        </div>
      </div>
    </div>

    <div class="current-account-card current-account-card--empty" *ngIf="!data.currentAccount">
      <p class="current-account-label">Cuenta de cargo actual no identificada</p>
    </div>

    <div class="field-full">
      <app-sis-select
        label="*Nueva cuenta de cargo"
        placeholder="Selecciona una cuenta"
        [options]="accountOptions"
        formControlName="selectedAccountCode">
      </app-sis-select>
    </div>

    <div class="selected-account-info" *ngIf="selectedAccount">
      <div class="selected-account-item">
        <span class="selected-account-sublabel">Nombre</span>
        <span class="selected-account-value">{{ selectedAccount.accountName }}</span>
      </div>
      <div class="selected-account-item">
        <span class="selected-account-sublabel">Tipo de cuenta</span>
        <span class="selected-account-value">{{ selectedAccount.accountType }}</span>
      </div>
    </div>

    <div class="field-full">
      <app-sis-select
        label="Agencia"
        placeholder="Escribe para obtener más opciones"
        [options]="agencyOptions"
        formControlName="agencyCode">
      </app-sis-select>
    </div>

  </div>

  <div class="cta-group">
    <button class="cta cta--outline" type="button" (click)="cancel()">Cancelar</button>
    <button class="cta cta--primary" type="button" (click)="onSubmit()" [disabled]="form.invalid || isSubmitting">
      {{ isSubmitting ? 'Enviando...' : 'Enviar solicitud' }}
    </button>
  </div>

</div>
